import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Availability.title',
    defaultMessage: 'Availability',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Availability.subtitle',
    defaultMessage: 'Your calendar should be updated at all times. We need to know when you are available for jobs and any scheduled unavailability you have planned for the future. Like this, we will be able to ensure deadlines for our clients and balance your workload.\n\nPlease come back to this page regularly to keep your scheduled unavailability updated.',
  },
  turnaroundSubtitle: {
    id: 'containers.SupplierProfile.components.Availability.turnaroundSubtitle',
    defaultMessage: 'Please provide your turnaround time for delivering recordings for 1-2 hour projects. As a Voice Star talent it is recommended to have a turnaround time of 24 hours, or less, to be considered for more jobs by clients',
  }
})
